import { BoxArrowUpRight, Github } from "react-bootstrap-icons";
import { Reveal } from "./Reveal";

export const ProjectCard = ({ title, description, tags = [], Icon, imgUrl, code, demo, delay = 0 }) => (
  <Reveal as="li" delay={delay} className="work-item">
    <article className="work-card">
      <div className={`work-art${imgUrl ? " has-image" : ""}`} aria-hidden="true">
        {imgUrl ? <img src={imgUrl} alt="" /> : Icon && <Icon size={30} />}
      </div>
      <h3>{title}</h3>
      <p>{description}</p>
      <ul className="work-tags">
        {tags.map((tag) => <li key={tag}>{tag}</li>)}
      </ul>
      <div className="work-actions">
        <a className="btn btn-ink" href={code} target="_blank" rel="noopener noreferrer" aria-label={`View code for ${title} on GitHub`}>
          <Github size={16} aria-hidden="true" /> View code
        </a>
        {demo && (
          <a className="btn btn-outline-ink" href={demo} target="_blank" rel="noopener noreferrer" aria-label={`Open the ${title} live demo`}>
            Live demo <BoxArrowUpRight size={14} aria-hidden="true" />
          </a>
        )}
      </div>
    </article>
  </Reveal>
);
